import iconMeetingLive from "../../../../../assets/images/meeting-live.svg";
import iconMic from "../../../../../assets/images/mir-red.svg";
import { useGlobal } from "../../../../../contexts/globalContext";
import useJanusVideoRoomActions from "../../../../../hooks/useJanusVideoRoomActions";

export const TopControllerBar = () => {
  const { MEETING_STATE, SET_MEETING_STATE } = useGlobal();

  const { videoRoomToggleAudio, videoRoomToggleVideo } = useJanusVideoRoomActions();

  const handleToggleAudio = () => {
    const { isAudioMuted } = MEETING_STATE.currentUser;
    const action = isAudioMuted.local ? "unmute" : "mute";

    videoRoomToggleAudio(action);
    // meetingRedisToggleAudio(id - 1, action);

    SET_MEETING_STATE((p) => ({
      ...p,
      currentUser: {
        ...p.currentUser,
        isAudioMuted: {
          ...p.currentUser.isAudioMuted,
          local: !p.currentUser.isAudioMuted.local,
          server: !p.currentUser.isAudioMuted.server,
        },
      },
    }));
  };

  const handleToggleVideo = () => {
    const { isVideoMuted } = MEETING_STATE.currentUser;
    const action = isVideoMuted.local ? "unmute" : "mute";

    videoRoomToggleVideo(action);
    // meetingRedisToggleVideo(id - 1, action);

    SET_MEETING_STATE((p) => ({
      ...p,
      currentUser: {
        ...p.currentUser,
        isVideoMuted: {
          ...p.currentUser.isVideoMuted,
          local: !p.currentUser.isVideoMuted.local,
          server: !p.currentUser.isVideoMuted.server,
        },
      },
    }));
  };
  return (
    <div className="video-confrance-top-controller">
      <div className="state-in-full-screenmode">
        <div className="bold"> Lorem ipsum dolor sit.</div>
        <div className="flex">
          <div className="flex">
            <img src={iconMeetingLive} width="10" className="m-r-5" alt="" />
            <div className="w-35 font-10"> LIVE</div>
          </div>
          <div className="font-10"> 25:05</div>
        </div>
      </div>
      <div className="controler-items-contaner">
        <div className="mouse-section" onClick={handleToggleAudio}>
          <img src={iconMic} className={`btn-32 btn-mic ${MEETING_STATE.currentUser.isAudioMuted?.local ? "disable" : ""}`} alt="" />
        </div>
        <div className="mouse-section" onClick={handleToggleVideo}>
          <img src={iconMic} className={`btn-32 btn-camera ${MEETING_STATE.currentUser.isVideoMuted?.local ? "disable" : ""}`} alt="" />
        </div>
      </div>
    </div>
  );
};
